import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, pipe, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { GenericService } from '@app/core/services/generic.service';

import { Loading, Agendamento } from '@app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class AgendamentoService extends GenericService<any> {

  constructor(http: HttpClient) {
    super('public/censo', http);
  };

  autenticarUsuario(cpf: string, dataNascimento: string, idCenso: number, loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().post(`${this.api}/agendamento/autenticar`, { headers: this.getHeadersPublico(), cpf, dataNascimento, idCenso })
      .pipe(this.configMapAndLoading(loading));
  }

  agendar(form: any, loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().post(`${this.api}/agendamento`, form, { headers: this.getHeadersPublico() })
      .pipe(this.configMapAndLoading(loading));
  }

  alterar(id: any, form: any, loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().put(`${this.api}/agendamento/${id}`, form, { headers: this.getHeadersPublico() })
      .pipe(this.configMapAndLoading(loading));
  }

  listarLocais(idCenso: number, loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().get<any>(`${this.api}/${idCenso}/agendamento/postos`, { headers: this.getHeadersPublico() })
      .pipe(this.configMapAndLoading(loading));
  }

  listarDatas(idCenso: number, id: number, loading?: Loading): Observable<any[]> {
    this.startLoading(loading);
    return this.getHttpClient().get<any[]>(`${this.api}/${idCenso}/agendamento/postos/${id}/datas`, { headers: this.getHeadersPublico() })
      .pipe(this.configMapAndLoading(loading));
  }

  listarHorarios(idCenso: number, idPosto: number, data: string, loading?: Loading): Observable<any[]> {
    this.startLoading(loading);
    return this.getHttpClient().get<any[]>(`${this.api}/${idCenso}/agendamento/postos/${idPosto}/horarios/${data}`, { headers: this.getHeadersPublico() })
      .pipe(this.configMapAndLoading(loading));
  }

  buscarAgendamentos(idCenso: number, cpf: string, loading?: Loading): Observable<Agendamento[]> {
    this.startLoading(loading);
    return this.getHttpClient().get<Agendamento[]>(`${this.api}/${idCenso}/agendamento/usuario/${cpf}`, { headers: this.getHeadersPublico() })
      .pipe(this.configMapAndLoading(loading));
  }

  cancelar(id: number, loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().delete<Agendamento[]>(`${this.api}/agendamento/${id}`, { headers: this.getHeadersPublico() })
      .pipe(this.configMapAndLoading(loading));
  }

  imprimirComprovante(id: number, loading?: Loading): Observable<Blob> {
    this.startLoading(loading);
    return this.getHttpClient().get(`${this.api}/agendamento/${id}/imprimir`, { headers: this.getHeadersPDFPublico(), responseType: 'blob' })
      .pipe(this.configMapAndLoading(loading));
  }

}
